/* eslint-disable no-console */

import { loadScript, loadStyle } from 'common/lib/loadScript';

/* global Calendly */

class CalendlyWidget {
  static isCalendlyEvent(event) {
    return event.data.event && event.data.event.indexOf('calendly') === 0;
  }

  constructor({ url, payload, onEventScheduled }) {
    this.url = new URL(url);
    this.payload = payload || {};
    this.enhancedUrl = this._buildUrl();
    this.onEventScheduled = onEventScheduled;
    this._handleMessageFn = this._handleMessage.bind(this);
    this.isLoaded = false;
    this._loadScripts();
  }

  connect() {
    window.addEventListener('message', this._handleMessageFn);
  }

  disconnect() {
    window.removeEventListener('message', this._handleMessageFn);
  }

  setUrl(url) {
    this.url = new URL(url);
    this.enhancedUrl = this._buildUrl();
  }

  closePopup() {
    if (typeof Calendly.closePopupWidget !== 'undefined') {
      Calendly.closePopupWidget();
    }
  }

  showPopup() {
    if (!this.isLoaded) {
      return;
    }

    const { client = {}, token } = this.payload;
    const { name = '', firstName = '', lastName = '', email = '' } = client;

    Calendly.initPopupWidget({
      url: this.enhancedUrl,
      prefill: {
        name,
        firstName,
        lastName,
        email,
      },
      utm: { utmContent: token },
    });
  }

  showInlineCalendlyWidgetForBMA() {
    const { client = {}, token } = this.payload;
    const { name = '', firstName = '', lastName = '', email = '' } = client;

    // if you wondering where is the box_container and calendly-inline-container,
    // check _pending_mobile.html.erb view. This view built for branded mobile app mobile client.
    // we're opening this view in a webview.
    const boxContainer = document.getElementById('box_container');
    const calendlyInlineContainer = document.getElementById('calendly-inline-container');
    boxContainer.style.display = 'none';
    calendlyInlineContainer.style.display = 'block';

    Calendly.initInlineWidget({
      url: this.enhancedUrl,
      parentElement: calendlyInlineContainer,
      prefill: {
        name,
        firstName,
        lastName,
        email,
      },
      utm: { utmContent: token },
    });
  }

  _buildUrl() {
    const { backgroundColor, textColor, primaryColor } = this.payload.pageSettings || {};

    if (backgroundColor)
      this.url.searchParams.set('background_color', this._stripColor(backgroundColor));
    if (primaryColor) this.url.searchParams.set('primary_color', this._stripColor(primaryColor));
    if (textColor) this.url.searchParams.set('text_color', this._stripColor(textColor));

    return this.url.toString();
  }

  _handleMessage(event) {
    if (!this.constructor.isCalendlyEvent(event)) {
      return;
    }

    if (event.data.event === 'calendly.event_scheduled' && this.onEventScheduled) {
      this.onEventScheduled(event.data.payload);
    }

    if (process.env.NODE_ENV === 'development') {
      console.log(event.data);
    }
  }

  _loadScripts() {
    loadStyle({
      id: 'calendly-widget-css',
      url: 'https://assets.calendly.com/assets/external/widget.css',
    });
    loadScript({
      id: 'calendly-widget-js',
      url: 'https://assets.calendly.com/assets/external/widget.js',
      callback: () => {
        this.isLoaded = true;
      },
    });
  }

  // Calendly color parameters should be without leading '#'
  _stripColor(value) {
    if (value.indexOf('#') === 0) {
      return value.substring(1);
    }
    return value;
  }
}
export default CalendlyWidget;
